import styled from 'styled-components'
import { Modal } from 'react-bootstrap'

export const StyledModalBody = styled(Modal.Body)`
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1rem;
`

export const StyledTable = styled.table`
  position: relative;
  width: 100%;

  th,
  td {
    padding: 8px;
  }

  thead > tr {
    background-color: #e2e2e2;
  }

  tbody > tr {
    cursor: pointer;

    border-top: 1px solid #e2e2e2;
    border-bottom: 1px solid #e2e2e2;

    &:nth-child(odd) {
      background-color: #ffffff;
    }

    &:nth-child(even) {
      background-color: #f2f2f2;
    }

    &:hover {
      background-color: #e2e2e2;
    }

    td {
      &:nth-child(1) {
        width: 20%;
      }

      &:nth-child(2) {
        width: 20%;
      }

      &:nth-child(3) {
        width: 20%;
      }

      &:nth-child(4) {
        width: 20%;
      }

      &:nth-child(5) {
        width: 20%;
      }
    }
  }
`

export const StatusText = styled.span`
  color: ${(props) => props.color};
  font-weight: 600;
`
